/* Glow House — Merken A–Z (sections/main-brands.liquid).
   Letter bar: smooth jump to a letter group, landing below the sticky header + bar; the active letter follows the scroll. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerWrap() { return document.querySelector('.gh-header-wrap'); }
  function hidesOnScroll() { var w = headerWrap(); return !!(w && w.querySelector('[data-hide-on-scroll]')); }
  function headerHeight() { var w = headerWrap(); return w ? w.offsetHeight : 0; }

  // Keep the bar exactly under the real header height (border included).
  var tracking = false;
  function trackHeader() {
    if (tracking) return;
    var w = headerWrap();
    if (!w) return;
    tracking = true;
    var set = function () { document.documentElement.style.setProperty('--gh-brands-header', w.offsetHeight + 'px'); };
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(w);
    set();
  }

  function init(root) {
    if (!root || root.dataset.brandsReady) return;
    var bar = root.querySelector('[data-brands-bar]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-brands-group]'));
    if (!bar || !groups.length) return;
    root.dataset.brandsReady = '1';
    trackHeader();

    var keyList = bar.querySelector('.gh-brands__keys');
    var keys = {};
    Array.prototype.forEach.call(bar.querySelectorAll('[data-brands-key]'), function (a) { keys[a.getAttribute('data-brands-key')] = a; });
    var current = null;

    // Mobile row: tell CSS which edge has more keys behind it.
    function fade() {
      if (!keyList) return;
      var max = keyList.scrollWidth - keyList.clientWidth;
      var x = keyList.scrollLeft;
      var v = max <= 1 ? '' : x <= 1 ? 'end' : x >= max - 1 ? 'start' : 'both';
      if (v) keyList.setAttribute('data-fade', v); else keyList.removeAttribute('data-fade');
    }
    if (keyList) {
      keyList.addEventListener('scroll', fade, { passive: true });
      window.addEventListener('resize', fade);
      fade();
    }

    function setActive(id) {
      if (id === current) return;
      if (current && keys[current]) { keys[current].classList.remove('is-active'); keys[current].removeAttribute('aria-current'); }
      current = id;
      var key = id && keys[id];
      if (!key) return;
      key.classList.add('is-active');
      key.setAttribute('aria-current', 'true');
      // Mobile: keep the active key visible in the horizontally scrolling row (never scrolls the page).
      if (keyList && keyList.scrollWidth > keyList.clientWidth) {
        var left = key.offsetLeft - (keyList.clientWidth - key.offsetWidth) / 2;
        keyList.scrollTo({ left: Math.max(0, left), behavior: reduced ? 'auto' : 'smooth' });
      }
    }

    // Where the group must land: below the bar, and below the header if it is (or will be) visible there.
    function targetTop(group) {
      var y = group.getBoundingClientRect().top + window.scrollY;
      var barH = bar.offsetHeight;
      var withHeader = y - headerHeight() - barH - 16;
      // theme.js slides the header away when scrolling down past 160px and back when scrolling up.
      var headerShown = !hidesOnScroll() || withHeader < window.scrollY || withHeader < 160;
      return Math.max(0, headerShown ? withHeader : y - barH - 16);
    }

    bar.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-brands-key]');
      if (!a) return;
      var id = a.getAttribute('data-brands-key');
      var group = document.getElementById(id);
      if (!group) return;
      e.preventDefault();
      lockUntil = Date.now() + 1200;
      setActive(id);
      window.scrollTo({ top: targetTop(group), behavior: reduced ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      var heading = group.querySelector('.gh-brands__letter');
      if (heading) { try { heading.focus({ preventScroll: true }); } catch (err) { /* old browsers */ } }
    });

    // Active letter while scrolling: the group crossing a band just under the bar.
    var lockUntil = 0;
    var visible = {};
    var io = null;
    function observe() {
      if (!('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      var top = headerHeight() + bar.offsetHeight + 24;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting; });
        if (Date.now() < lockUntil) return;
        var hit = null;
        for (var i = 0; i < groups.length; i++) { if (visible[groups[i].id]) { hit = groups[i].id; break; } }
        if (hit) setActive(hit);
        else if (groups[0].getBoundingClientRect().top > top) setActive(null);
      }, { rootMargin: '-' + top + 'px 0px -55% 0px', threshold: 0 });
      groups.forEach(function (g) { io.observe(g); });
    }
    observe();
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(observe, 200); });
    // After a programmatic jump, hand control back to the observer.
    window.addEventListener('scrollend', function () { lockUntil = 0; });

    if (location.hash && keys[location.hash.slice(1)]) setActive(location.hash.slice(1));
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-brands]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
